import { Autocomplete } from "@material-ui/lab";
import React from "react";
import FormControl from "@material-ui/core/FormControl";
import { TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const MsCashManagerSelect = ({
  managers,
  checkedManager,
  setCheckedManager,
  isObject = true,
  defaultOption = false
}) => {
  const { t } = useTranslation("otherInterface");

  return (
    <>
      <FormControl>
        <Autocomplete
          options={(isObject ? managers : managers.map(manager => manager.email)) || []}
          value={checkedManager || null}
          onChange={(event, checkedManager) => setCheckedManager(checkedManager)}
          getOptionLabel={(option) => isObject ? option.email : option}
          renderInput={(params) => (
            <TextField {...params} label={t("msCash.managers")} />
          )}
          blurOnSelect
          disableClearable={!defaultOption}
        />
      </FormControl>
    </>
  );
};

export default MsCashManagerSelect;